import { post } from '../index';

export const resetUserPassword = body => {
  return post('/users/profile-reset-password', body);
};
